export default "__VITE_ASSET__q89gUk5Q__"